/* unplugin-vue-components disabled */const { ref, computed } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-f1b035be"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "list-wrap" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "数字信号", -1));
const _hoisted_4 = { class: "panle" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "模拟信号", -1));
const _hoisted_7 = { class: "panle" };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "十进制信号", -1));
const _hoisted_10 = { class: "panle" };
const _hoisted_11 = { style: { "display": "flex", "text-align": "center", "gap": "5px", "align-items": "center" } };
const _hoisted_12 = { class: "out-in-type-label" };
const model_1 = require("@/model");
const work_1 = require("@/store/modules/work");
const index_vue_1 = tslib_1.__importDefault(require("@/components/DeleteBtn/index.vue"));
const index_vue_2 = tslib_1.__importDefault(require("@/components/SensitiveInput/index.vue"));
const NumericsItem_vue_1 = tslib_1.__importDefault(require("./NumericsItem.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'IOPanel',
    setup(__props, { expose: __expose }) {
        const newIOSelect = ref([]);
        const IN_OUT = [
            {
                value: '输入',
                label: '输入',
            }, {
                value: '输出',
                label: '输出',
            }
        ];
        const NEW_IO_OPTIONS = [
            {
                value: '数字信号',
                label: '数字信号',
                options: IN_OUT
            },
        ];
        const store = (0, work_1.useWork)();
        const curRobot = computed(() => { var _a, _b; return (_b = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram) === null || _b === void 0 ? void 0 : _b.robot; });
        const numerics = computed(() => ioList.value.filter(e => (e.type == model_1.IO_TYPE.DI || e.type == model_1.IO_TYPE.DO)));
        const analogs = computed(() => ioList.value.filter(e => (e.type == model_1.IO_TYPE.AI || e.type == model_1.IO_TYPE.AO)));
        const decimals = computed(() => ioList.value.filter(e => (e.type == model_1.IO_TYPE.GI || e.type == model_1.IO_TYPE.GO)));
        const ioList = computed(() => {
            if (!curRobot.value) {
                return [];
            }
            let feedBinIos = [];
            curRobot.value.paths.forEach(path => {
                if (path.ioId) {
                    feedBinIos.push(path.ioId);
                }
            });
            return curRobot.value.code.ioList.filter(io => !feedBinIos.includes(io.id));
        });
        const decSelectRef = ref();
        const newNameOptions = ref([]);
        function remoteMethod(query, item) {
            if (!curRobot.value)
                return;
            query = query.trim();
            let forceName = query != '' && !isNaN(Number(query)) ? Number(query) : 1;
            let res = [];
            let names = curRobot.value.code.usingNames(model_1.IO_TYPE.GO);
            for (let i = 0; i < 9 - item.using.length && item.using.length < 8; i++) {
                let newName = forceName;
                while (names.find(e => e == `#${newName}`) || res.find(e => e.label == `#${newName}`)) {
                    newName++;
                }
                res.push({
                    label: `#${newName}`,
                    value: `#${newName}`
                });
            }
            newNameOptions.value = res;
        }
        function onDecInput(value) {
            if (decSelectRef.value) {
                decSelectRef.value.forEach(e => e.input.value = e.input.value.replace(/\D/g, ""));
            }
        }
        function handleNewIOVar(command) {
            if (!curRobot.value)
                return;
            let ioVar = {};
            switch (command[0]) {
                case NEW_IO_OPTIONS[0].value:
                    ioVar.type = command[1] === IN_OUT[0].value ? model_1.IO_TYPE.DI : model_1.IO_TYPE.DO;
                    ioVar.dict = [{ val: 1, text: '' }, { val: 0, text: '' }];
                    break;
                case NEW_IO_OPTIONS[1].value:
                    ioVar.type = command[1] === IN_OUT[0].value ? model_1.IO_TYPE.AI : model_1.IO_TYPE.AO;
                    break;
                case NEW_IO_OPTIONS[2].value:
                    ioVar.type = command[1] === IN_OUT[0].value ? model_1.IO_TYPE.GI : model_1.IO_TYPE.GO;
                    ioVar.using = [];
                    break;
            }
            curRobot.value.code.addIO(ioVar.name, ioVar.type, 0, '', ioVar.using, ioVar.dict);
        }
        __expose({
            handleNewIOVar,
            NEW_IO_OPTIONS
        });
        function handleIoChange(name, remark, item) {
            item.name = name;
            item.remark = remark;
            store.notifyChangeIO(item);
        }
        function handleDelIO(item) {
            if (!curRobot.value)
                return;
            store.notifyDeleteIO(item);
            curRobot.value.code.delIO(item.id);
        }
        return (_ctx, _cache) => {
            const _component_el_option = (0, vue_2.resolveComponent)("el-option");
            const _component_el_select = (0, vue_2.resolveComponent)("el-select");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.unref)(numerics).length != 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        _hoisted_3,
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(numerics), (item) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: item.id,
                                    style: { "display": "flex", "gap": "3px", "align-items": "center", "justify-content": "center" }
                                }, [
                                    (0, vue_2.createVNode)(NumericsItem_vue_1.default, {
                                        item: item,
                                        onOnChange: (name, remark) => handleIoChange(name, remark, item),
                                        handleDelIO: handleDelIO
                                    }, null, 8, ["item", "onOnChange"])
                                ]));
                            }), 128))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(analogs).length != 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                        _hoisted_6,
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(analogs), (item) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: item.id,
                                    style: { "display": "flex", "gap": "3px", "align-items": "center", "justify-content": "center" }
                                }, [
                                    (0, vue_2.createVNode)(NumericsItem_vue_1.default, {
                                        item: item,
                                        onOnChange: (name, remark) => handleIoChange(name, remark, item),
                                        handleDelIO: handleDelIO
                                    }, null, 8, ["item", "onOnChange"])
                                ]));
                            }), 128))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(decimals).length != 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                        _hoisted_9,
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(decimals), (item) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: item.id,
                                    class: "decimal-item"
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                        (0, vue_2.createVNode)(index_vue_2.default, {
                                            model: item.name,
                                            "onUpdate:model": ($event) => ((item.name) = $event),
                                            class: "name-label"
                                        }, null, 8, ["model", "onUpdate:model"]),
                                        (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)(item.type === (0, vue_2.unref)(model_1.IO_TYPE).GI ? '输入' : '输出'), 1),
                                        (0, vue_2.createVNode)(index_vue_2.default, {
                                            model: item.remark,
                                            "onUpdate:model": ($event) => ((item.remark) = $event),
                                            placeholder: "请输入注释",
                                            class: "remark-input"
                                        }, null, 8, ["model", "onUpdate:model"]),
                                        (0, vue_2.createVNode)(index_vue_1.default, {
                                            title: "确定删除这个I/O吗?",
                                            onDelConfirm: ($event) => (handleDelIO(item))
                                        }, null, 8, ["onDelConfirm"])
                                    ]),
                                    (0, vue_2.createVNode)(_component_el_select, {
                                        modelValue: item.using,
                                        "onUpdate:modelValue": ($event) => ((item.using) = $event),
                                        multiple: "",
                                        filterable: "",
                                        remote: "",
                                        "reserve-keyword": "",
                                        placeholder: "请选择或添加使用的IO口",
                                        "remote-method": (query) => remoteMethod(query, item),
                                        onClick: ($event) => (remoteMethod('', item)),
                                        "multiple-limit": 8,
                                        ref_for: true,
                                        ref_key: "decSelectRef",
                                        ref: decSelectRef,
                                        onInput: onDecInput
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(newNameOptions), (item) => {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_option, {
                                                    key: item.label,
                                                    label: item.label,
                                                    value: item.value
                                                }, null, 8, ["label", "value"]));
                                            }), 128))
                                        ]),
                                        _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method", "onClick"])
                                ]));
                            }), 128))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
